import React from 'react';
import PropTypes from 'prop-types';
import { Filters } from '../../../../../constants/filter/filters';
import { MissingValue } from './missing_value';

function DimensionsMissing({ highlight, filters }) {
    const containerClassName = ['statusbar-mobile-current-status__size-cta'];

    if (highlight) {
        containerClassName.push('statusbar-mobile-current-status__size-cta--highlight-' + highlight);
    }

    return (
        <span className={containerClassName.join(' ')}>
            {filters[Filters.WIDTH] &&
                filters[Filters.HEIGHT] &&
                filters[Filters.DIAMETER] &&
                filters[Filters.WIDTH] + '/' + filters[Filters.HEIGHT] + 'R' + filters[Filters.DIAMETER]}
        </span>
    );
}

DimensionsMissing.propTypes = {
    filters: PropTypes.object.isRequired,
    highlight: PropTypes.string,
};

DimensionsMissing.defaultProps = {
    highlight: ''
};

export { DimensionsMissing };
